import useClientPagination from 'hooks/use-client-pagination'
import UrlPagination from 'components/molecules/url-pagination'
import React, { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { Alert, Button, Card, CardBody, Form, FormGroup, Input, Label, Table } from 'reactstrap'
import TitlePage from 'components/atoms/title-page'

const API = 'api/v2/admins/settings/banks'
const emptyForm = { name: '', bank_code: '' }

const BankPage = () => {
  const [ banks, setBanks ] = useState([])
  const [ canUpdate, setCanUpdate ] = useState(false)
  const [ query, setQuery ] = useState('')
  const [ form, setForm ] = useState(emptyForm)
  const [ editingId, setEditingId ] = useState(null)
  const [ busy, setBusy ] = useState(false)
  const [ loading, setLoading ] = useState(true)
  const [ error, setError ] = useState('')
  const [ message, setMessage ] = useState('')

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const response = await axios.get(API)
      setBanks(response.data.banks || [])
      setCanUpdate(response.data.can_update === true)
    } catch (failure) {
      setError(failure.response?.data?.message || 'Gagal memuat Bank.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [ load ])

  const save = async (event) => {
    event.preventDefault()
    if (busy || loading || (editingId && !canUpdate)) return
    setError('')
    setMessage('')
    if (!form.name.trim() || (form.bank_code && !/^\d{3}$/.test(form.bank_code))) {
      setError('Nama bank wajib diisi; kode bank harus 3 digit (contoh 014), atau kosong bila belum diketahui.')
      return
    }
    setBusy(true)
    try {
      const payload = { bank: form }
      if (editingId) await axios.patch(`${API}/${editingId}`, payload)
      else await axios.post(API, payload)
      setForm(emptyForm)
      setEditingId(null)
      setMessage('Bank berhasil disimpan.')
      await load()
    } catch (failure) {
      setError(failure.response?.data?.message || 'Gagal menyimpan Bank.')
    } finally {
      setBusy(false)
    }
  }

  const filtered = banks.filter((bank) => `${bank.name} ${bank.bank_code || ''}`.toLowerCase().includes(query.toLowerCase()))

  const listPagination = useClientPagination(filtered, { loading: loading })

  return (
    <>
      <TitlePage mainTitle='Setting' subTitle='Bank' />
      <Card><CardBody>
        { error && <Alert color='danger'>{ error }</Alert> }
        { message && <Alert color='success'>{ message }</Alert> }
        <Form onSubmit={ save }>
          <h4>{ editingId ? 'Edit Bank' : 'Tambah Bank' }</h4>
          <FormGroup><Label for='bank-name'>Nama Bank</Label><Input id='bank-name' required value={ form.name } disabled={ busy || loading } onChange={ (event) => setForm({ ...form, name: event.target.value }) } /></FormGroup>
          <FormGroup><Label for='bank-code'>Kode Bank (3 digit)</Label><Input id='bank-code' type='text' inputMode='numeric' maxLength={ 3 } placeholder='014' value={ form.bank_code } disabled={ busy || loading } onChange={ (event) => setForm({ ...form, bank_code: event.target.value }) } /><small>Kosongkan bila belum diketahui. Angka nol di depan tetap tersimpan.</small></FormGroup>
          <Button color='primary' disabled={ busy || loading } type='submit'>{ busy ? 'Menyimpan...' : 'Simpan Bank' }</Button>
          { editingId && <Button className='ml-2' disabled={ busy } onClick={ () => { setEditingId(null); setForm(emptyForm) } }>Batal Edit</Button> }
        </Form>
      </CardBody></Card>
      <Card><CardBody>
        <Input aria-label='Cari Bank' className='mb-3' placeholder='Cari nama / kode bank' value={ query } onChange={ (event) => { listPagination.setPage(1); setQuery(event.target.value) } } />
        <Table responsive bordered><thead><tr><th>Nama Bank</th><th>Kode Bank</th>{ canUpdate && <th>Aksi</th> }</tr></thead><tbody>
          { listPagination.rows.map((bank) => <tr key={ bank.id }><td>{ bank.name }</td><td>{ bank.bank_code || 'Belum diisi' }</td>{ canUpdate && <td><Button size='sm' disabled={ busy } onClick={ () => { setEditingId(bank.id); setForm({ name: bank.name, bank_code: bank.bank_code || '' }); setError(''); setMessage(''); window.scrollTo(0, 0) } }>Edit</Button></td> }</tr>) }
          { !filtered.length && <tr><td colSpan={ canUpdate ? 3 : 2 }>{ loading ? 'Memuat...' : 'Tidak ada bank.' }</td></tr> }
        </tbody></Table>
          <UrlPagination pagination={ listPagination } loading={ loading } />
      </CardBody></Card>
    </>
  )
}

export default BankPage
